import React, { useState } from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const [showNumbers, setShowNumbers] = useState(false);
  
  const phoneNumbers = [
    { number: '918077894559', display: '+91 8077894559' },
    { number: '917983864997', display: '+91 79838 64997' }
  ];
  
  const message = 'Hello, I am interested in Shikhar Dhara products. Please provide more information.';

  const openWhatsApp = (phoneNumber) => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    setShowNumbers(false);
  };

  return (
    <div className="whatsapp-container">
      {showNumbers && (
        <div className="whatsapp-numbers">
          {phoneNumbers.map((phone, index) => (
            <button
              key={index}
              className="whatsapp-number-option"
              onClick={() => openWhatsApp(phone.number)}
            >
              <div className="whatsapp-icon-small">
                <svg viewBox="0 0 32 32" fill="currentColor">
                  <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.154-1.97C9.87 30.904 12.834 32 16.004 32 24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.508 22.584c-.396 1.116-1.956 2.04-3.206 2.31-.858.184-1.978.33-5.752-1.236-4.828-2.002-7.936-6.902-8.176-7.222-.23-.32-1.936-2.578-1.936-4.916 0-2.34 1.226-3.488 1.662-3.966.396-.434.924-.612 1.376-.612.166 0 .316.008.452.016.478.02.718.05 1.034.8.396.938 1.36 3.324 1.478 3.566.12.244.242.57.086.906-.144.35-.27.506-.514.778-.244.272-.474.48-.718.774-.228.26-.486.536-.208.994.278.458 1.236 2.042 2.654 3.306 1.824 1.626 3.362 2.13 3.836 2.364.396.196.868.156 1.154-.156.366-.4.816-1.064 1.274-1.72.326-.466.738-.522 1.174-.352.44.16 2.786 1.314 3.262 1.552.478.24.796.356.914.554.116.198.116 1.148-.28 2.26z"/>
                </svg>
              </div>
              <span>{phone.display}</span>
            </button>
          ))}
        </div>
      )}
      
      <button
        className="whatsapp-float"
        onClick={() => setShowNumbers(!showNumbers)}
        aria-label="Chat on WhatsApp"
      >
        <div className="whatsapp-icon">
          <svg viewBox="0 0 32 32" fill="currentColor">
            <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.154-1.97C9.87 30.904 12.834 32 16.004 32 24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.508 22.584c-.396 1.116-1.956 2.04-3.206 2.31-.858.184-1.978.33-5.752-1.236-4.828-2.002-7.936-6.902-8.176-7.222-.23-.32-1.936-2.578-1.936-4.916 0-2.34 1.226-3.488 1.662-3.966.396-.434.924-.612 1.376-.612.166 0 .316.008.452.016.478.02.718.05 1.034.8.396.938 1.36 3.324 1.478 3.566.12.244.242.57.086.906-.144.35-.27.506-.514.778-.244.272-.474.48-.718.774-.228.26-.486.536-.208.994.278.458 1.236 2.042 2.654 3.306 1.824 1.626 3.362 2.13 3.836 2.364.396.196.868.156 1.154-.156.366-.4.816-1.064 1.274-1.72.326-.466.738-.522 1.174-.352.44.16 2.786 1.314 3.262 1.552.478.24.796.356.914.554.116.198.116 1.148-.28 2.26z"/>
          </svg>
        </div>
        <span className="whatsapp-tooltip">Chat with us</span>
      </button>
    </div>
  );
};

export default WhatsAppButton;
